import moment from 'moment'
import { AutoComplete } from 'qbs-core'
import { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'

import { Button } from '../../common'
import CustomDatePicker from '../../common/inputs/CustomDatePicker'
import TextArea from '../../common/inputs/TextArea'

interface CustomeChildTableProps {
  tableData: any[]
  onChange: (data: any[]) => void
  minDate: any
  disabled: boolean
  value?: any
  errors?: any
  name?: string
  className?: string
  highlight?: any
  statusEnabled?: boolean
  customEdit?: boolean
  actionsFields?: any
  actionsAppend?: any
  actionsRemove?: any
  actions?: any
  currentTab?: string
  progressReportMonths?: number
  isEditable?: boolean
}

const CustomeChildTable: React.FC<CustomeChildTableProps> = ({
  tableData,
  onChange,
  minDate,
  disabled,
  errors,
  highlight,
  statusEnabled,
  customEdit,
  actionsAppend,
  actions,
  isEditable,
  currentTab,
  progressReportMonths = 12,
}) => {
  const { setValue } = useFormContext()
  const [error, setErrors] = useState<string | null>(null)
  const [errorFlag, setErrorFlag] = useState(false)
  const [targetErrorArray, setTargetErrorArray] = useState<any>()
  useEffect(() => {
    const targetErrorsArray = errors?.targetErrors
      ? Object.values(errors.targetErrors).filter(Boolean)
      : []
    setTargetErrorArray(targetErrorsArray)
  }, [errors])
  useEffect(() => {
    // const targetErrorsArray = errors?.targetErrors
    //   ? Object.values(errors.targetErrors).filter(Boolean)
    //   : []
    // setTargetErrorArray(targetErrorsArray)

    if (
      highlight?.length === 0 &&
      targetErrorArray?.length > 0
      // errors &&
      // errors.targetErrors &&
      // Object.keys(errors.targetErrors).length > 0
    ) {
      setErrorFlag(true)
    } else {
      setErrorFlag(false)
    }
  }, [tableData, highlight, targetErrorArray])

  const maxLength = 400
  const whoMaxLength = 65
  const { clearErrors } = useFormContext()
  const handleChange = (e: any, ind: number, key: string) => {
    const updatedActions = [...tableData]
    if (e?.target?.value || e?.value) {
      clearErrors(key)
    }
    if (key === 'by_when') {
      const date = e.value ? new Date(e.value) : null
      updatedActions[ind][key] = date ? moment(date).format('YYYY-MM-DD') : ''
    } else if (key === 'who') {
      const value = e.target.value.slice(0, whoMaxLength)
      updatedActions[ind][key] = value

      if (e.target.value?.length > whoMaxLength) {
        setErrors(`Max ${whoMaxLength} Characters`)
      } else {
        setErrors(null)
      }
    } else {
      const value = e.target.value.slice(0, maxLength)
      updatedActions[ind][key] = value

      if (e.target.value?.length > maxLength) {
        setErrors(`Max ${maxLength} Characters`)
      } else {
        setErrors(null)
      }
    }
    onChange(updatedActions)
  }

  // The issue is likely that all new rows are given the same id 'new', so when editing, React can't distinguish between them.
  // Instead, generate a truly unique id for each new row.
  const handleAddRow = () => {
    const uniqueId = 'new'
    const newRow = {
      id: uniqueId, // Generate unique ID for each new row
      milestone: '',
      by_when: '',
      who: '',
      status: statusEnabled ? 'not_started' : '',
      sort: tableData.length + 1,
    }
    actionsAppend(newRow)
  }

  const getDate = (date: any) => {
    return date ? moment(date).format('DD-MM-YYYY') : ''
  }
  const getError = () => {
    const keys = ['by_when', 'milestone', 'who']
    let message = ''
    if (errors && Object.keys(errors)?.length > 0) {
      Object.keys(errors)?.forEach((itemKey: any) => {
        if (keys.includes(itemKey)) {
          message = errors[itemKey]?.message
        }
      })
    }
    return message
  }
  // const getItemError = (key: string) => {
  //   let valid = false
  //   if (errors && Object.keys(errors)?.length > 0) {
  //     Object.keys(errors)?.forEach((itemKey: any) => {
  //       if (key.includes(itemKey)) {
  //         valid = true
  //       }
  //     })
  //   }
  //   return valid
  // }
  const isHighlight = (fieldKey: string): boolean => {
    const match = fieldKey.match(/actions\[(\d+)\]\.(.*)/)

    if (!match) {
      return false
    }

    const [, indexStr, field] = match
    const index = parseInt(indexStr, 10)

    if (errorFlag) {
      return (
        targetErrorArray?.some(
          (item: any) =>
            item.field === field && item.subkey === `actions_${index + 1}` // Adjust index to match subkey format
        ) ?? false
      )
    } else {
      if (tableData[index]) {
        return highlight
          ? (highlight?.some(
              (item: any) =>
                item.field === field && item.subkey === `actions_${index + 1}` // Adjust index to match subkey format
            ) ?? false)
          : false
      }
    }

    return false
  }
  const statusData = [
    {
      id: 'not_started',
      name: 'Not Started',
    },
    {
      id: 'in_progress',
      name: 'In Progress',
    },
    {
      id: 'on_hold',
      name: 'On Hold',
    },

    {
      id: 'cancelled',
      name: 'Cancelled',
    },
    {
      id: 'completed',
      name: 'Completed',
    },
  ]
  const handleStatusChange = (e: any, ind: number) => {
    setValue(`actions.${ind}.status`, e.id)
  }
  const handleStatusChangeForPr2 = (e: any, ind: number) => {
    setValue(`actions.${ind}.pr1_status_for_pr2`, e.id)
  }
  return (
    <div className="">
      <table className="w-full align-middle child-table border-separate border-spacing-0">
        <thead>
          <tr>
            <th className="text-left px-2 py-2.5 bg-bgGrey border border-b-0 border-r-0 rounded-tl-md text-xxs leading-4">
              Actions
            </th>
            <th className="text-left px-2 py-2.5 bg-bgGrey border-t text-xxs leading-4 w-8">
              When
            </th>
            <th
              className={`text-left px-2 py-2.5 bg-bgGrey border-t    text-xxs leading-4 w-44 ${statusEnabled ? '' : 'border-r rounded-tr-md'}`}
            >
              Responsible Person
            </th>
            {statusEnabled && (
              <>
                {currentTab === 'progress1' && (
                  <th className="text-left px-2 py-2.5 bg-bgGrey border-t border-r  rounded-tr-md text-xxs leading-4 w-44">
                    {progressReportMonths} Months Status
                  </th>
                )}
                {currentTab === 'progress2' && (
                  <>
                    <th className="text-left px-2 py-2.5 bg-bgGrey border-t border-r  rounded-tr-md text-xxs leading-4 w-44">
                      12 Months Status
                    </th>
                    <th className="text-left px-2 py-2.5 bg-bgGrey border-t border-r  rounded-tr-md text-xxs leading-4 w-44">
                      24 Months Status
                    </th>
                  </>
                )}
              </>
            )}
          </tr>
        </thead>
        <tbody
          className={`${disabled || (customEdit && !disabled) ? 'bg-grey-lightHover ' : 'bg-white'}`}
        >
          {tableData?.map((item, index) => (
            <tr key={item.id}>
              <td className="border border-b-0 border-formBorder text-left align-top">
                <TextArea
                  id=""
                  disabled={
                    customEdit
                      ? actions[index]?.is_main_action || isEditable
                      : disabled
                  }
                  value={item.milestone ? item.milestone : ''}
                  rows={3}
                  // errorFlag={
                  //   index == 0 && getItemError('milestone') ? true : false
                  // }
                  onChange={(e) => handleChange(e, index, 'milestone')}
                  name={`milestone`}
                  // className={`${isHighlight(`actions[${index}].milestone`) ? 'textfield-highlight' : ''}`} //textfield-error
                  className={`${isHighlight(`actions[${index}].milestone`) ? (errorFlag ? 'textfield-error' : 'textfield-highlight') : ''}`}
                />
              </td>
              <td
                // className={`border-t border-formBorder w-32  align-top ${isHighlight(`actions[${index}].by_when`) ? 'textfield-highlight' : ''}`}
                className={`border-t border-formBorder w-32  align-top ${!disabled && isHighlight(`actions[${index}].by_when`) ? (errorFlag ? 'textfield-error' : 'textfield-highlight') : ''}`}
              >
                <CustomDatePicker
                  onChange={(date) => handleChange(date, index, 'by_when')}
                  key={`actions[${index}].by_when`}
                  name={`by_when`}
                  value={item.by_when}
                  disabled={
                    customEdit
                      ? actions[index]?.is_main_action || isEditable
                      : disabled
                  }
                  minDate={minDate}
                  // errors={index == 0 ? errors : undefined}
                  // errorFlag={
                  //   index == 0 && getItemError('by_when') ? true : false
                  // }
                  viewValue={getDate(item.by_when)}
                  // className={`${isHighlight(`actions[${index}].by_when`) ? 'textfield-highlight' : ''}`}
                  className={`${isHighlight(`actions[${index}].by_when`) ? (errorFlag ? 'textfield-error' : 'textfield-highlight') : ''}`}
                />
              </td>
              <td className="border border-b-0 border-formBorder input-area  align-top">
                <TextArea
                  id=""
                  rows={3}
                  disabled={
                    customEdit
                      ? actions[index]?.is_main_action || isEditable
                      : disabled
                  }
                  // errorFlag={index == 0 && getItemError('who') ? true : false}
                  value={item.who ? item.who : ''}
                  onChange={(e) => handleChange(e, index, 'who')}
                  name={`who`}
                  // className={`${isHighlight(`actions[${index}].who`) ? 'textfield-highlight' : ''}`}
                  className={`${isHighlight(`actions[${index}].who`) ? (errorFlag ? 'textfield-error' : 'textfield-highlight') : ''}`}
                />
              </td>
              {statusEnabled && (
                <>
                  {currentTab === 'progress1' && (
                    <td className="border border-b-0 border-formBorder input-area    align-center">
                      {(item.milestone || item.by_when || item.who) && (
                        <AutoComplete
                          id={`actions.status`}
                          data={statusData}
                          disabled={disabled}
                          className="w-full !h-full hide-btn"
                          type="custom_select"
                          onChange={(e) => handleStatusChange(e, index)}
                          name={`status`}
                          value={
                            statusData.find(
                              (st) =>
                                item.status === st.id || item.status === st.name
                            )?.name || ''
                          }
                          desc="name"
                          descId="id"
                        />
                      )}
                    </td>
                  )}
                  {currentTab === 'progress2' && (
                    <>
                      <td className="border border-b-0 border-formBorder input-area    align-center">
                        {(item.milestone || item.by_when || item.who) && (
                          <AutoComplete
                            id={`actions.pr1_status_for_pr2`}
                            data={statusData}
                            disabled={true}
                            className="w-full !h-full hide-btn"
                            type="custom_select"
                            onChange={(e) => handleStatusChangeForPr2(e, index)}
                            name={`status`}
                            value={
                              statusData.find(
                                (st) =>
                                  item.pr1_status_for_pr2 === st.id ||
                                  item.pr1_status_for_pr2 === st.name
                              )?.name || ''
                            }
                            desc="name"
                            descId="id"
                          />
                        )}
                      </td>
                      <td className="border border-b-0 border-formBorder input-area    align-center">
                        {(item.milestone || item.by_when || item.who) && (
                          <AutoComplete
                            id={`actions.status`}
                            data={statusData}
                            disabled={disabled}
                            className="w-full !h-full hide-btn"
                            type="custom_select"
                            onChange={(e) => handleStatusChange(e, index)}
                            name={`status`}
                            value={
                              statusData.find(
                                (st) =>
                                  item.status === st.id ||
                                  item.status === st.name
                              )?.name || ''
                            }
                            desc="name"
                            descId="id"
                          />
                        )}
                      </td>
                    </>
                  )}
                </>
              )}
            </tr>
          ))}
        </tbody>
      </table>
      {error && (
        <div className="text-error text-error-label mt-[1px]">{error}</div>
      )}
      {errors && (
        <div className="text-error text-error-label mt-[1px]">{getError()}</div>
      )}

      {!disabled && customEdit && (
        <div className="mt-3">
          <Button
            label="Add New Row"
            outlined
            className="flex items-center gap-2"
            onClick={handleAddRow}
            icon={'plus'}
            size="xs"
          />
        </div>
      )}
    </div>
  )
}

export default CustomeChildTable
